import { UserService } from './user.service';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/internal/operators/map';
import { Role } from '../models';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService,
    private userService: UserService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this.authService.currentUserValue && Object.keys(this.authService.currentUserValue).length > 0) {
      const currentUser = this.authService.currentUserValue;
      // Check if user has a payment subscription before going to dashboard page
      if (currentUser.role === Role.Individual && !currentUser.isSubscribed) {
        this.router.navigate(['/sign-in']);
        return false;
      }
      if (route.data.roles && route.data.roles.indexOf(currentUser.role) === -1) {
        // Role not authorised so redirect to dashboard
        this.router.navigate(['/user/dashboard']);
        return false;
      }
      // Authorised so return true
      return true;
    } else {

      if (route.data.roles && route.data.roles.indexOf(Role.Admin) >= 0) {
        // redirect user to sing in if not logged in

        /*
        const currentUser = this.authService.currentUserValue;
        if (Object.keys(currentUser).length == 0) {
          this.router.navigate(['/sign-in']);
          return false;
        }
        */

        let tokenValue = this.authService.tokenValue;
        if (tokenValue == null) {
          this.router.navigate(['/sign-in']);
          return false;
        }

        return true;
      }

      // Fallback if there's no stored user's value consume API instead
      return this.userService.getProfile()
      .pipe(map(userData => {
        if (userData.success) {
          const currentUser = userData.data.user;
          // Check if user has a payment subscription before going to dashboard page
          if (currentUser.role === Role.Individual && !currentUser.is_subscribed) {
            this.router.navigate(['/sign-in']);
            return false;
          }
          if (route.data.roles && route.data.roles.indexOf(currentUser.role) === -1) {
            // Role not authorised so redirect to dashboard
            this.router.navigate(['/user/dashboard']);
            return false;
          }
          // Authorised so return true
          return true;
        }
        // Not logged in so redirect to sign in page with the return url
        this.router.navigate(['/sign-in'], {
          queryParams: {
            returnUrl: state.url
          }
        });
        return false;
      }));
    }

  }

}
